<template>
  <feedback-table kind="misconduct" title="Misconduct" />
</template>

<script>
import FeedbackTable from './FeedbackTable'

export default {
  name: 'EmployeesMisconduct',
  components: { FeedbackTable },
}
</script>
